import styled from 'styled-components';

export const AssetFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AssetFormInfo = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const FieldsTitle = styled.p`
  font-size: 18px;
`;
